import { Component, inject } from "@angular/core";

import { UserLocationService } from "@bitwarden/web-vault/app/services/location/user-location.service";

@Component({
  selector: "user-location",
  templateUrl: "./user-location.component.html",
})
export class UserLocationComponent {
  protected userLocationService = inject(UserLocationService);
  protected readonly iconName = "plus-account";
  protected readonly iconSvgClass =
    "tw-translate-y-[2px] tw-translate-x-[1px] tw-h-12 tw-w-12 md:tw-h-9 md:tw-w-9 md:tw--translate-y-[1px] md:tw--translate-x-[0.1px]";

  protected readonly locations: { code: "AU" | "US"; labelKey: string }[] = [
    { code: "AU", labelKey: "au" },
    { code: "US", labelKey: "us" },
  ];
}
